import React, { useState, useEffect, useCallback } from 'react';
import { PostMemberAttestation } from '../../api/memberAttestation/list';  // 导入 API 请求
import clsx from 'clsx';  // 用于动态生成 className
import styles from './ListOfCompanies.module.scss';  // 引入样式
import zhCN from 'antd/es/locale/zh_CN';
import { Card, Button, Table, Pagination, Spin, ConfigProvider, Empty } from 'antd';  // 导入 Ant Design 组件
import { CloseCircleFilled } from '@ant-design/icons';  // 导入图标
import { useLocation, useNavigate } from 'react-router-dom';
import iconBack from '../../static/home/icon_back.png'
// 导航列表数据
const navList = [
  { value: 1, name: '产品认证证书查询' },
  { value: 2, name: '服务认证证书查询' },
  { value: 3, name: '评估评价证书查询' }
];

// 导航项组件，接收 `name`（名称）、`active`（是否激活）、`onClick`（点击事件）作为 props
const NavItem = ({ name, active, onClick }) => (
  <div className={clsx(styles.navItem, { [styles.active]: active })} onClick={onClick}>
    {name}
    {active && <div className={styles.underline}></div>}  {/* 激活状态下显示下划线 */}
  </div>
);

const ListOfCompanies = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // 使用 useState 创建不同的状态
  const [loading, setLoading] = useState(false);  // 是否加载中
  const [tableData, setTableData] = useState([]);  // 表格数据
  const [isOnShow, setIsOnShow] = useState(false);  // 是否显示详情
  const [activeKey, setActiveKey] = useState(1);  // 当前激活的导航项
  const [companyName, setCompanyName] = useState('');  // 公司名称
  const [companyId, setCompanyId] = useState('');  // 公司 ID
  const [isPDF, setIsPDF] = useState(false);  // 是否为 PDF 文件
  const [imageAddress, setImageAddress] = useState('');  // 图片或 PDF 地址
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10); // 默认每页条数
  const [totalPages, setTotalPages] = useState(0);
  const [columns, setColumns] = useState([
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>序号</span>,
      dataIndex: 'key',
      render: (text, record, index) => index + 1,
      width: 60,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>证书编号</span>,
      dataIndex: 'attestationNumber',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      width: 180,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>产品名称</span>,
      dataIndex: 'attestationName',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      width: 160,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>产品型号</span>,
      dataIndex: 'attestationModel',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      flex: 1,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>认证依据</span>,
      dataIndex: 'certificationBasis',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      flex: 1,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>生产地址</span>,
      dataIndex: 'productionAddress',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      flex: 1,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>发证日期</span>,
      dataIndex: 'issueDate',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      width: 120,
    },
    {
      title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>状态</span>,
      dataIndex: 'status',
      render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
      width: 80,
    },
    {
      title: <span style={{ color: '#666666', paddingRight: '20px' }} className={styles.columnsfontsize}>证书详情</span>,
      dataIndex: 'certificateDetails',
      flex: 1,
      align: 'right',
      render: (text, record) => (
        <Button type="link" onClick={() => openRenders(record)}
          className={styles.columnsfontBtn}
          style={{ background: '#E78110', color: '#fff', fontSize: '14px' }}
        >
          点击查看
        </Button>
      ),
    },
  ]);
  // 请求数据的函数
  const getResponseData = useCallback(async (type, pageSize, currentPage) => {

    const statusMap = {
      0: '有效',
      1: '暂停',
      2: '撤销',
      3: '注销',
    };
    try {
      // 发起 API 请求，获取证书数据
      const { data } = await PostMemberAttestation({
        memberId: companyId,
        pageIndex: currentPage,
        pageSize: pageSize,  // 使用传入的每页数量        ,
        attestationType: type,
        displayStatus: 1
      });
      const list = data.data.map(item => ({
        ...item,
        status: statusMap[item.status] || '未知状态',  // 显示状态对应的中文
        issueDate: item.issueDate ? item.issueDate.substring(0, 10) : '---',
      }));

      setTableData(list);  // 设置表格数据
      setTotal(data.totalCount);  // 设置总页数
      setTotalPages(data.totalPages);
    } catch (error) {
      console.log(error);  // 错误处理
    } finally {
      setLoading(false);  // 请求完成，恢复加载状态
    }
  }, [companyId, loading]);  // 依赖 companyId 和 loading，确保数据获取时使用最新的公司 ID 和加载状态



  // 处理导航项点击事件
  const handleItemClick = useCallback(async (value) => {
    setLoading(true);
    setActiveKey(value);  // 设置激活的导航项
    getResponseData(value, pageSize);  // 获取对应类型的数据
    if (value === 1) {
      setColumns([
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>序号</span>,
          dataIndex: 'key',
          render: (text, record, index) => index + 1,
          width: 60,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>证书编号</span>,
          dataIndex: 'attestationNumber',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          width: 180,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>产品名称</span>,
          dataIndex: 'attestationName',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          width: 160,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>产品型号</span>,
          dataIndex: 'attestationModel',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>认证依据</span>,
          dataIndex: 'certificationBasis',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>生产地址</span>,
          dataIndex: 'productionAddress',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>发证日期</span>,
          dataIndex: 'issueDate',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          width: 120,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>状态</span>,
          dataIndex: 'status',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          width: 80,
        },
        {
          title: <span style={{ color: '#666666', paddingRight: '20px' }} className={styles.columnsfontsize}>证书详情</span>,
          dataIndex: 'certificateDetails',
          flex: 1,
          align: 'right',
          render: (text, record) => (
            <Button type="link" onClick={() => openRenders(record)}
              className={styles.columnsfontBtn}
              style={{ background: '#E78110', color: '#fff', fontSize: '14px' }}
            >
              点击查看
            </Button>
          ),
        },

      ]);
    } else {
      setColumns([
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>序号</span>,
          dataIndex: 'key',
          render: (text, record, index) => index + 1,
          width: 60,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>证书编号</span>,
          dataIndex: 'attestationNumber',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>认证依据</span>,
          dataIndex: 'certificationBasis',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>发证日期</span>,
          dataIndex: 'issueDate',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666' }} className={styles.columnsfontsize}>状态</span>,
          dataIndex: 'status',
          render: (text) => <span className={styles.columnsfontsize}>{text}</span>,
          flex: 1,
        },
        {
          title: <span style={{ color: '#666666', paddingRight: '20px' }} className={styles.columnsfontsize}>证书详情</span>,
          dataIndex: 'certificateDetails',
          flex: 1,
          align: 'right',
          render: (text, record) => (
            <Button type="link" onClick={() => openRenders(record)}
              className={styles.columnsfontBtn}
              style={{ background: '#E78110', color: '#fff', fontSize: '14px' }}
            >
              点击查看
            </Button>
          ),
        },


      ]);
    }
  }, [getResponseData]);  // 依赖 getResponseData，确保每次该函数变化时更新


  // 打开证书详情
  const openRenders = (record) => {
    const bloos = record.imageAddress.endsWith('.pdf');  // 判断是否为 PDF 文件
    setIsPDF(bloos);  // 设置是否为 PDF
    setImageAddress(record.imageAddress);  // 设置证书详情的地址
    setIsOnShow(true);  // 显示详情
  };

  // 关闭详情视图
  const closeImgs = () => {
    setIsOnShow(false);  // 隐藏详情视图
  };


  // 页码改变时请求新的数据
  const handlePageChange = (page) => {
    console.log('page', page);
    setCurrentPage(page);
  };
  const handlePageSizeChange = async (current, size) => {
    await setPageSize(size); // 更新每页显示条数
    setCurrentPage(current); // 重置为第一页，防止出现分页越界
  };
  const previousPageBtn = () => {
    if (currentPage === 1) return;
    setLoading(true);
    handlePageSizeChange(currentPage - 1, 10)
  }
  const nextPageBtn = () => {
    if (currentPage === Math.ceil(totalPages)) return;
    setLoading(true);
    handlePageSizeChange(currentPage + 1, 10)
  }


  // 当 memberItem 改变时，更新公司名称和 ID
  useEffect(() => {
    setCompanyName(queryParams.get('name'));
    setCompanyId(queryParams.get('id'));
  }, []);  // 依赖 memberItem，当它变化时重新执行

  // 当公司 ID 或激活的导航项变化时，获取数据
  useEffect(() => {
    if (companyId) {
      getResponseData(activeKey, pageSize, currentPage);
    }
    const media = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(media.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  }, [companyId, activeKey, currentPage, pageSize]);  // 依赖 companyId 和 activeKey，确保这两者变化时重新获取数据

  const rowClass = (record, index) => index % 2 === 0 ? styles.evenRow : styles.oddRow;
  const toDetail = (record) => {
    const queryParams = new URLSearchParams({
      attestationModel: record.attestationModel,
      attestationName: record.attestationName,
      attestationNumber: record.attestationNumber,
      attestationType: activeKey,
      certificationBasis: record.certificationBasis,
      closingDate: record.closingDate,
      createAt: record.createAt,
      createBy: record.createBy,
      displayStatus: record.displayStatus,
      id: record.id,
      imageAddress: record.imageAddress,
      issueDate: record.issueDate,
      memberName: record.memberName,
      productionAddress: record.productionAddress,
      status: record.status,
    });
    // 跳转到目标路由，传递查询参数
    navigate(`/detail?${queryParams.toString()}`);

  };

  if (isMobile) {
    return (
      <ConfigProvider locale={zhCN} style={{ width: '100%' }}>
        <Spin spinning={loading} size="large" tip="加载中...">
          {!loading && tableData && tableData.length > 0 && (

            <div className={styles.mobiles}>
              <nav className={styles.navClass}>
                {navList.map(item => (
                  <NavItem
                    key={item.value}
                    name={item.name}
                    active={activeKey === item.value}
                    onClick={() => handleItemClick(item.value)}
                  />
                ))}
              </nav>
              <div className={styles.mobileList}>
                <div className={styles.yangshi}>
                  {tableData.map(item => (
                    <div key={item.id}
                      onClick={() => toDetail(item)}
                      className={styles.listItem} >
                      <div className={styles.listItemContent}>
                        <div className={styles.listItemTitle}>{activeKey == 1 ? item.attestationName : item.certificationBasis}</div>
                        <div className={styles.listItemDescription}>{item.attestationNumber}</div>
                      </div>
                      <img className={styles.logotopImgs} src={iconBack} alt="Logo" />
                    </div>
                  ))}
                </div>
              </div>
              {
                total > 10 && (<div className={styles.pagesBtns}>
                  <div onClick={previousPageBtn} className={currentPage == 1 ? styles.previousPageNo : styles.previousPage}>上一页</div>
                  <div onClick={nextPageBtn} className={currentPage == totalPages ? styles.previousPageNo : styles.previousPage}>下一页</div>
                </div>)
              }
            </div>
          )}
          {
            !loading && tableData && tableData.length === 0 && (
              <div className={styles.mobiles}>
                <nav className={styles.navClass}>
                  {navList.map(item => (
                    <NavItem
                      key={item.value}
                      name={item.name}
                      active={activeKey === item.value}
                      onClick={() => handleItemClick(item.value)}
                    />
                  ))}
                </nav>
                <Empty description="暂无数据" style={{ marginTop: '50px' }} />
              </div>

            )
          }
        </Spin>
      </ConfigProvider >
    );
  }
  //  桌面端
  return (
    <ConfigProvider locale={zhCN}>
      <Spin spinning={loading} size="large" tip="加载中...">
        {!loading && (
          <div className={styles.ListOfCompanies}>
            <div className={styles.title}>
              <div className={styles.lins}></div>
              <div className={styles.titleName}>{companyName}</div>
            </div>
            <div className={styles.contentsList}>
              <nav className={styles.navClass}>
                {navList.map(item => (
                  <NavItem
                    key={item.value}
                    name={item.name}
                    active={activeKey === item.value}
                    onClick={() => handleItemClick(item.value)}
                  />
                ))}
              </nav>
              <Card bordered={false} style={{ width: '100%', marginTop: '15px', minHeight: '700px' }}>
                {/* scroll={{ x: 'max-content' }} */}
                <Table columns={columns} dataSource={tableData} pagination={false}
                  rowClassName={rowClass}
                />
                <div className={styles.flootClass}>

                  <Pagination
                    style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}
                    current={currentPage}
                    pageSize={pageSize}
                    total={total}
                    onChange={handlePageChange}
                    onShowSizeChange={handlePageSizeChange} // 监听每页条数变化
                    showSizeChanger
                  // showQuickJumper

                  />
                  <div style={{ paddingLeft: '15px' }}>共{totalPages}页</div>
                  <div style={{ paddingLeft: '15px' }}>共{total}条记录</div>
                </div>
              </Card>
            </div>
          </div>
        )}
        {isOnShow && (
          <div onClick={closeImgs} className={styles.etCety}>
            <div className={styles.bottomBtns}>
              <div style={{ background: '#fff' }}>
                {isPDF ? (
                  <div style={{ position: 'relative', width: '700px', height: '100vh' }}>
                    <iframe
                      src={`${imageAddress}#toolbar=0&navpanes=0&scrollbar=0`}
                      title="PDF Preview"
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        backgroundColor: '#fff',
                        overflow: 'auto', // 确保 PDF 内容可以滚动
                      }}
                    ></iframe>
                  </div>
                ) : (
                  <div className={styles.containerStyle}>
                    <img src={imageAddress} alt="" className={styles.imageStyle} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Spin>
    </ConfigProvider>
  );
};

export default ListOfCompanies; 
